import React from 'react';
import {
  Anchor,
  IconTelephone,
  dlsBrightBlue,
  IconDocument,
  IconLock,
} from '@americanexpress/dls-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useProductContext } from '../Product';

const SideBar = () => {
  const { product: { productShortName, telephoneNumber } } = useProductContext();
  const {
    messages: {
      links: {
        lockIconLink,
        [productShortName]: { paperIconLink },

      },
    },
  } = useIntl();
  return (
    <div>
      <h2 className="heading-5 pad-1-b">
        <FormattedMessage id="sidebar.header" />
      </h2>
      <hr className="dls-gray-03-bg" style={{ height: '1px' }} />
      <div className="stack pad-1-t">
        <ul style={{ listStyle: 'none', padding: '0' }}>
          <li>
            <Anchor
              href={paperIconLink}
              className="flex flex-align-items-center margin-0-b pad-0-b"
              target="_blank"
              reactlytics={{ element: 'MembershipConditions', detail: 'BYB' }}
            >
              <IconDocument theme={dlsBrightBlue} className="pad-1-r" />
              <FormattedMessage id="paperIcon.label" />
            </Anchor>
          </li>
          <li>
            <Anchor
              href={lockIconLink}
              className="flex flex-align-items-center margin-0-b pad-0-b"
              target="_blank"
              reactlytics={{ element: 'DataProtectionDeclaration', detail: 'BYB' }}
            >
              <IconLock theme={dlsBrightBlue} className="pad-1-r" />
              <FormattedMessage id="lockIcon.label" />
            </Anchor>
          </li>
          <li>
            <Anchor
              href={`tel:${telephoneNumber}`}
              className="flex flex-align-items-center"
              reactlytics={{ element: 'CallNumber', detail: 'BYB' }}
            >
              <IconTelephone theme={dlsBrightBlue} className="pad-1-r" />
              <FormattedMessage id="telephone.label" />
            </Anchor>
          </li>
        </ul>
      </div>
    </div>
  );
};
export default SideBar;
